import { create } from "zustand";
import { persist } from "zustand/middleware";

interface GameState {
  currentLocation: string;
  playerGold: number;
  playerBadges: string[];
  playerUsername: string;
  playerAvatarId: string;

  setCurrentLocation: (locationId: string) => void;
  /** Overwrite gold with the authoritative value from the server. */
  setGold: (amount: number) => void;
  addGold: (amount: number) => void;
  spendGold: (amount: number) => boolean;
  addBadge: (badgeId: string) => void;
}

export const useGameStore = create<GameState>()(
  persist(
    (set, get) => ({
      currentLocation: "siida",
      playerGold: 0,
      playerBadges: [],
      playerUsername: "Spiller",
      playerAvatarId: "default",

      setCurrentLocation: (locationId) => set({ currentLocation: locationId }),

      setGold: (amount) => set({ playerGold: amount }),

      addGold: (amount) =>
        set((state) => ({ playerGold: state.playerGold + amount })),

      spendGold: (amount) => {
        const { playerGold } = get();
        if (playerGold < amount) return false;
        set((state) => ({ playerGold: state.playerGold - amount }));
        return true;
      },

      addBadge: (badgeId) =>
        set((state) => ({
          playerBadges: state.playerBadges.includes(badgeId)
            ? state.playerBadges
            : [...state.playerBadges, badgeId],
        })),
    }),
    {
      name: "gollegiella-game",
      partialize: (state) => ({
        currentLocation: state.currentLocation,
        playerGold: state.playerGold,
        playerBadges: state.playerBadges,
        playerUsername: state.playerUsername,
        playerAvatarId: state.playerAvatarId,
      }),
    }
  )
);
